<main class="site-content fix-height">
  <div class="container align-center">
    <div class="message">
      <img src="../../assets/images/404.svg" />
      <p class="main-message green">Sorry, we're down for maintainance</p>
      <span class="sub-message">We'll be back shortly</span>
    </div>
  </div>
</main>
